<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getClinicsData)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="诊室名称">
            <el-input v-model="searchForm.clinicName" placeholder="请输入诊室名称" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getClinicsData, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getClinicsData, { clinicName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button" v-if="deptId">
        <el-button icon="el-icon-plus" type="primary" @click="addclinic">新增诊室</el-button>
      </div>
      <!-- 诊室列表 -->
      <el-table v-loading="loading" :max-height="tableHeight" :data="clinicList" border>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="clinicName" label="诊室名称" />
        <el-table-column prop="deptName" label="所属医馆" v-if="!deptId" />
        <el-table-column prop="updateBy" label="操作员" />
        <el-table-column prop="createTime" label="创建时间" min-width="150" />
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editClinic(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="340px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="诊室名称" prop="clinicName">
            <el-input v-model="editForm.clinicName" placeholder="请输入诊室名称" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增诊室'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑诊室'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getClinicsData)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script lang="js">
import { clinicList, clinicEdit, clinicAdd } from "@/api/clinic"; // 诊室请求
export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { clinicName: null }, // 查询表单
      clinicList: [], // 诊室列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      editFormRules: { clinicName: [{ required: true, message: "诊室名称不能为空！", trigger: "blur" }] }, // 验证规则
      deptId: this.$session.get("deptId"),
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getClinicsData(); // 页面初始化获取诊室列表
  },
  methods: {
    // 请求所有诊室列表
    async getClinicsData() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await clinicList(params);

      if (code == 200) {
        this.total = total;
        rows.forEach(item => {
          this.$session.get("options").forEach(items => {
            if (item.deptId == items.value) item.deptName = items.label;
          });
        })
        this.clinicList = rows;
      }
      this.loading = false;
    },
    // 新增诊室
    addclinic() {
      this.dialogVisible = true;
      this.dialogTitle = "新增诊室";
      this.editForm = { clinicName: null, deptId: this.deptId };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          clinicAdd(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("新增诊室成功！");
            this.dialogVisible = false;
            this.$refresh(this.getClinicsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑诊室信息
    async editClinic(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑诊室";
      this.dialogVisible = true;
    },
    // 保存诊室修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          clinicEdit(this.editForm).then(res => {
            let { code } = res;
            if (code == 200) this.$message.success("修改诊室成功！");

            this.dialogVisible = false;
            this.$refresh(this.getClinicsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>
